<template>
    <div>
        
        <!-- <table class="table" v-if="data != null">
            <thead>
                <tr>
                    <th>Series</th>
                    <th>Color</th>
                    <th>1 Month</th>
                    <th>2 Months</th>
                    <th>3 Months</th>
                    <th>3-6 Months</th>
                    <th>>6 Months</th>
                </tr>
            </thead>
            <tbody class="detailStockTable" v-if="data.length != 0">
                <tr v-for="dat in data">
                    <td>{{ dat.series }}</td>
                    <td>{{ dat.color_desc }}</td>
                    <td>{{ numberWithCommas(dat.month_1) }}</td>
                    <td>{{ numberWithCommas(dat.month_2) }}</td>
                    <td>{{ numberWithCommas(dat.month_3) }}</td>
                    <td>{{ numberWithCommas(dat.month_3_6) }}</td>
                    <td>{{ numberWithCommas(dat.month_6) }}</td>
                </tr>
            </tbody>
            <p v-else style="margin: 20px 0 0 0; text-align: center; font-size: 20px; text-shadow: 1px 1px 1px grey">No Data</p>
        </table> -->
        <table class="table" v-if="data != null">
            <thead>
                <tr>
                <th v-for="column in columns" @click="sortMe(column.key)">
                    {{ column.title }}
                    <span v-if="filter.by === column.key">
                    <span v-if="filter.order === 'ASC'">
                        <i class="fas fa-sort-up"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort-down"></i>
                    </span>
                    </span>
                    <span v-else>
                    <i class="fas fa-sort"></i>
                    </span>
                </th>
                </tr>
            </thead>
            <tbody class="detailStockTable" v-if="data.length != 0">
                <tr v-for="dat in sortedData">
                <td v-for="column in columns">{{ dat[column.key] }}</td>
                </tr>
            </tbody>
            <p v-else style="margin: 20px 0 0 0; text-align: center; font-size: 20px; text-shadow: 1px 1px 1px grey">
                No Data
            </p>
        </table>

        <div style="min-height: 400px; display: flex; align-items: center; justify-content: center;" v-else>
            <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
        </div>

    </div>
</template>

<script>
    export default {
        data () {
            return {
                dummyData : null,
                data: null,
                filter: {
                    by: null,
                    order: 'ASC'
                },
                columns: [
                    { key: 'series', title: 'Series' },
                    { key: 'color_desc', title: 'Color' },
                    { key: 'month_1', title: '1 Month' },
                    { key: 'month_2', title: '2 Months' },
                    { key: 'month_3', title: '3 Months' },
                    { key: 'month_3_6', title: '3-6 Months' },
                    { key: 'month_6', title: '>6 Months' }
                ]
            }
        },
        props : ['data'],
        mounted () {
            this.generateDummyData();
        },
        computed: {
            sortedData() {
            if (!this.data) return null;

            let sortedData = [...this.data];
            if (this.filter.by) {
                sortedData.sort((a, b) => {
                const aValue = a[this.filter.by];
                const bValue = b[this.filter.by];
                return this.filter.order === 'ASC' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
                });
            }
            return sortedData;
            }
        },
        methods : {
            generateDummyData () {
                let dummy = [];

                let names = ['Beat', 'Scoopy', 'Beatstreet', 'ADV 150', 'Genio']
                for (var i = 0; i < 20; i++) {
                    let singleDummy = {
                        type : `Honda ${names[this.randomInt(0, 100)%names.length]} ${names[this.randomInt(0, 100)%names.length]}`,
                        color : 'All Color',
                        month_1 : this.randomInt(0, 1000),
                        month_2 : this.randomInt(0, 1000),
                        month_3 : this.randomInt(0, 1000),
                        month_3_6 : this.randomInt(0, 1000),
                        month_6 : this.randomInt(0, 1000)
                    }
                    dummy.push(singleDummy);
                }

                this.dummyData = dummy;
            },
            sortMe(column) {
                if (this.filter.by === column) {
                    this.filter.order = this.filter.order === 'ASC' ? 'DESC' : 'ASC';
                } else {
                    this.filter.by = column;
                    this.filter.order = 'ASC';
                }
            }
        }
    }
</script>

<style scoped>
    tbody {
        display: block;
        max-height: 400px;
        overflow-y: scroll;
    }

    thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    thead {
        width: calc(100% - 10px);
    }

    thead tr th {
        border-bottom: 0.5px solid #FF0009;
        font: normal normal 500 14px/16px Ubuntu;
        color: #707070;
    }

    tbody tr td {
        font: normal normal 500 13px/14px Ubuntu;
        color: #707070;
    }

    thead tr th,
    tbody tr td {
        vertical-align: middle;
    }

    .detailStockTable::-webkit-scrollbar{
        width:10px;
    }
    .detailStockTable::-webkit-scrollbar-track{
        background-color: white;
        border-radius: 20px;
    }
    .detailStockTable::-webkit-scrollbar-thumb{
        background-color: #F1F1F1;
        border-radius: 20px;
    }
</style>